import { Component } from "@angular/core";
import { Router } from "@angular/router";

import { WalletEditComponent } from "../wallet-edit.component";
import { Helper } from "@helpers/functions";
import { TradableWallet } from "@models/interfaces/tradable_wallet";
import { Tradable } from "@models/interfaces/tradable";
import { TradableTransaction } from "@models/transaction";
import { TradableWalletService } from "@main-services/wallet/tradable_wallet.service";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { TradableService } from "@main-services/currency/tradable.service";
import { InfoService } from "@core-services/info.service";
import { ConfirmModalService } from "@core-services/confirm-modal.service";

@Component({
	selector: "wallet-rename",
	templateUrl: "./wallet-rename.component.html",
	styleUrls: ["./wallet-rename.component.scss"],
	standalone: false
})
export class WalletRenameComponent extends WalletEditComponent<Tradable> {
	public constructor(
		protected tradableWalletListService: TradableWalletListService,
		protected tradableListService: TradableListService,
		private router: Router,
		private infoService: InfoService,
		protected confirmModalService: ConfirmModalService
	) {
		super();
		this.isRenameMode = true;
	}

	protected callObservableAfterView(): void {
		this.getWalletObservable().subscribe(
			(wallet: TradableWallet) => this.setWalletData(wallet),
			(error) => {
				this.router.navigateByUrl("/portfolio");
				this.infoService.setError(error);
			}
		);
	}

	public saveWallet(): void {
		if (!this.data.wallet.dirty) {
			return;
		}
		this.tradableWalletService.setName(this.data.wallet).subscribe({
			next: () => {
				this.infoService.setSuccess(this.translationService.translate("my_account_settings_name_saved"));
				this.close();
			},
			error: (error) => Helper.handleError(error, this.data.wallet)
		});
	}

	protected get tradableWalletService(): TradableWalletService<TradableWallet, TradableTransaction, Tradable> {
		return this.tradableWalletListService.serviceForId(this.data.wallet.getId());
	}
	protected get tradableService(): TradableService<Tradable> {
		return this.tradableListService.serviceForId(this.data.wallet.getCurrencyId());
	}

	public deleteWallet(): void {
		this.close();
		const sub = this.confirmModalService
			.showConfirmModal("delete-wallet-warning-title", "delete-wallet-warning", "ok", "cancel")
			.subscribe((yes) => {
				if (sub) {
					sub.unsubscribe();
				}
				if (yes) {
					this.tradableWalletService.deleteWallet(this.data.wallet).subscribe({
						next: () => this.router.navigateByUrl("/portfolio"),
						error: (error) => this.infoService.setError(error)
					});
				}
			});
	}

	protected setWalletData(wallet: TradableWallet): void {
		if (wallet == null) {
			if (!this.data.wallet) {
				this.router.navigateByUrl("/portfolio");
			}
			return;
		}
		wallet.setAddresses(
			wallet
				.getAddresses()
				.filter((w) => !w.isDisabled())
				.sort((a, b) => b.getLastUpdated().getUnix() - a.getLastUpdated().getUnix())
		);
		this.data.wallet = wallet;
	}
}
